import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { ProjectService } from 'app/services';
import { ToastNotificationService } from 'app/components';

@Component({
  selector: 'app-project-logo',
  templateUrl: './project-logo.component.html',
  styleUrls: ['./project-logo.component.scss']
})
export class ProjectLogoComponent implements OnChanges {
  @Input() projectId: number;

  public picture: string;
  public uploadImage: File;
  public isAttached: boolean;
  public filePath: string;
  public isDefaultImage: boolean;

  @Output() imageSelected: EventEmitter<File> = new EventEmitter<File>();

  constructor(
    private projectService: ProjectService,
    private notificationService: ToastNotificationService
  ) {}

  ngOnChanges(): void {
    if (this.projectId) {
      this.picture = this.projectService.getProjectLogo(this.projectId, true);
      this.resetImageSelected();
    }
  }

  public chooseImage(e) {
    const file = (e.target as HTMLInputElement).files[0];
    if (file) {
      const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      if (parseInt(sizeInMB, 10) >= 1) {
        this.notificationService.showMessage(
          'File size exceeds the maximum allowed size (1MB)',
          'Error'
        );
      } else {
        this.uploadImage = file;
        this.isAttached = true;
        this.isDefaultImage = false;

        const reader = new FileReader();
        reader.onload = () => {
          this.filePath = reader.result as string;
        };
        reader.readAsDataURL(file);

        this.imageSelected.emit(file);
      }
    }
  }

  public onImageError(event: Event): void {
    this.isDefaultImage = true;
    (event.target as HTMLImageElement).src = 'assets/images/upload-image.jpg';
  }

  public resetImageSelected() {
    this.uploadImage = null;
    this.isAttached = false;
    this.isDefaultImage = true;
    this.filePath = 'assets/images/upload-image.jpg';
    this.imageSelected.emit(null);
    this.preloadLogo();
  }

  private preloadLogo(): void {
    if (!this.picture) {
      return;
    }
    const logoUrl = this.picture;
    const image = new Image();
    image.onload = () => {
      if (this.picture === logoUrl) {
        this.filePath = logoUrl;
        this.isDefaultImage = false;
      }
    };
    image.src = logoUrl;
  }
}
